import SlideType from '@app/types/presentations/SlideType';

/**
 * Slides as contained in a section or chapter (via IChapterItem)
 */
export default interface ISlideMaster {
	id: string;
	dateUpdated?: string;
	type: SlideType;
	fields: any;
}

export function isSlideMaster(slide: ISlideMaster | any): slide is ISlideMaster {
	return (
		!!(slide as ISlideMaster) &&
		(slide as ISlideMaster).id !== undefined &&
		(slide as ISlideMaster).type !== undefined &&
		(slide as ISlideMaster).fields !== undefined
	);
}
